import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const Courses = () => {
     useEffect(() => {
        document.title = 'Courses -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
     <li>  Academics  </li> 
     <li>Courses </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Courses  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <h3> <b>Kindergarten</b> </h3>
       <p>Attending kindergarten means having more structure in a children’s younger stage of life as they are ready for it after going to a preschool. They have learned to socialize, follow simple rules, and stay on a task longer. They are now ready for more intense learning and this is an opportune time for a teacher to harness the mind yet still keep the fun and adventure of a kindergartener’s mind going. </p> 
       <p>Young children learn best with experiential learning. They love to experience the world physically. Their curiosity leads them to ask many questions that connect ideas in their minds. Kindergartners have a natural curiosity and want to learn about how the world works. Our early education teacher builds on this enthusiasm of the young learner by encouraging them to probe deeper into the area that interests them. </p> 
       <p>Respect for all, responsibility, and accountability of their actions, are all the characteristics that they acquire while going to our kindergarten. Independence is another key attribute that students learn in their early years. Our school believes in imparting good moral values from a younger age, therefore, helping the needy, empathy for their fellow peers, sharing with others are also inculcated among the students. Along with their emotional and intelligence quotient, our teachers also focus on their physical attributes and creativity. The academics and activities are designed in such a way that there is overall development in their motor skills and cognition. Utmost care is taken for every child and special care is taken for children with special needs such as lisping and slow to learn and provide help and assistance to help them learn and progress at their own pace. </p>
       
       <p>Some of the facilities provided for the young minds are: </p> 
       </div>
       
       <div className="col-lg-6">
         <ul className="list"> 
       <li>Mother teacher</li>
       <li>Outside playground</li>
       <li>Swings, monkey-bars, carousel, see-saw</li>
       <li>Digital classrooms</li> 
        </ul>
       </div>
       <div className="col-lg-6">
         <ul className="list">  
       <li>Indoor playroom</li>
       <li>Dedicated care-takers</li>
       <li>Washrooms (separate for boys and girls)</li>
        </ul>
       </div>
        
            <div className="col-lg-12">
            <h3><b>Primary School</b></h3>
            <p>The primary stage entails the age group of 6 to 10 years. It is the stage where students build their autonomy and space in the social circle through academic and other achievements. They are observing their environment critically and constantly learning from it. It's critical for them as they are developing personality traits, grit, curiosity and study habits to make decisions about their future. They are highly active and motivated at this age, both intrinsically and extrinsically. Thus, the environment set at this age for them is highly important and crucial. . </p>

            <p>Primary school marks the beginning of formal education. It plays a pivotal role in our education system as other levels of education build upon this foundational stage of school education. In simple terms, the quality of primary education defines the characteristics of a student to some extent, strengthens their previous knowledge and aligns their development in the right path. It is the fundamental need of our education system and good quality education can prove to be beneficial in the long term education. Therefore, it becomes an obligatory duty and bounded responsibility of the school to make primary education meaningful and joyful to every child. </p>

            <p>Our school takes the responsibility of providing primary education diligently and ensures that the students are given the right education and environment to grow freely without burdening them. Our activity-based and experiential learning curriculum is following the National Curriculum Framework (NCF) 2020 which envisages our education system holistically. Various activities and competitions are organised for the students. They are encouraged to participate in both, intra-school and inter-school, competitions to uncover their natural aptitude and give them exposure to the outside world. </p>

            <p>Facilities provided for the unique and inquisitive minds are: </p>
            </div>
            <div className="col-lg-4">
                     <ul className="list"> 
                    <li>Outside playground </li> 
                    <li>Digital classrooms </li>
                    <li>Indoor Activity room </li>
                    <li>Computer Labs </li> 
                    <li>Language Lab </li>
                    <li>Social Science Lab </li>
                   
                    </ul>  
            </div>
            <div className="col-lg-4">
                     <ul className="list"> 
                    <li>Art & Craft Room </li>
                    <li>Music Room </li> 
                    <li>Library </li> 
                    <li>Reading Room </li>
                    <li>Band Group </li>
                    <li>Karate Classes </li>
                    </ul>
                    </div>
                    <div className="col-lg-4"> 
                     <ul className="list">
                    <li>Yoga Classes </li>
                    <li>Dance Classes </li>
                    <li>Abacus Classes </li>
                    <li>French Classes </li>
                    <li>Washrooms (separate for boys and girls) </li>
                    </ul>
                    </div>
                    <div className="col-lg-12">
                    <h3><b> Secondary School</b></h3>
                   
                   <p>Secondary education occupies a very strategic position in the educational pattern of the country. It is the link between primary education and higher education. Primary education is intended to provide minimum requirements for survival whereas secondary education enables an individual to become a full member of the complicated society.
                  
                  </p>
                  <p>Middle schoolers have very different needs than kindergarteners and primary students. Their bodies begin to change, their emotions feel stronger, and their thoughts get more internal and complex. Every day they confront issues that shape their morality and future place in society. There are several ways to tell just how important middle to secondary school years are. You can do this just by asking a handful of people when they first really succeeded or struggled in school and when they remember first developing their social and emotional patterns. The habits that adolescents develop academically and socially are critical. Education is the bridge that helps them to tackle their internal and external problems.
                  
                  </p>
                  <p>Our school realises these developmental changes and provides a conducive environment for them to learn, socialise, express and foster their skills for their future endeavours. They are encouraged to engage not only in scholastic activities such as Olympiads and Scholarship Programs but also other co-scholastic activities such as Music, Karate, Band, Yoga, Art-Craft, Dance, Theatre, Scout Programs, SEWA Club, Eco Club, etc. Even though our school is young but we consistently and constantly take newer initiatives to let our students grow in all spheres of life.
                  
                  </p>
                  <p>As our previous alumni will gladly be able to tell, ST. PETER’S CONVENT SCHOOL has been thriving in continuously catering to the needs of its students for several years now. Facilities provided for the Secondary School are: </p>
                   
                  </div>
                  <div className="col-lg-4">
                     <ul className="list">
                  <li>Outside playground </li>
                  <li>Digital classrooms </li>
                  <li>Indoor Activity room </li>
                  <li>Computer Labs </li>
                  <li>Language Lab </li>
                  <li>Social Science Lab </li>
                  <li>Chemistry Lab </li>
                  </ul>
                  </div>
                  <div className="col-lg-4">
                     <ul className="list">
                  <li>Physics Lab </li>
                  <li>Biology Lab </li>
                  <li>Art & Craft Room </li>
                  <li>Music Room </li>
                  <li>Library </li>
                  <li>Reading Room </li>
                  </ul>
                  </div>
                  <div className="col-lg-4">
                     <ul className="list">
                  <li>Band Group </li>
                  <li>Karate Classes </li>
                  <li>Yoga Classes </li>
                  <li>Dance Classes </li>
                  <li>Abacus Classes </li>
                  <li>French Classes </li>
                  <li>Washrooms (separate for boys and girls)</li>
                  </ul>
                  </div>
                  
                  <div className="col-lg-12">
                  <h3><b>Online Fee Payment Facilities</b></h3> 
                   
                  <p>The school has made school-fee payment facilities hassle-free for parents and guardians. They have the option to choose the payment facility and pay the fees using the school app, net banking, cheque or cash. Cheque and cash must get submit directly to the bank i.e. South Indian Bank.
                  
                  </p>
                  <p>The school app is having a facility that can help parents to make fee payments quarter-wise, and the school need not follow up for the remaining fee. Students can log in to the school app to see the due amount and can select the required option to make fee payments.
                  
                  </p>
                  <p>After submitting the quarter fee through net banking, parents are requested to share the transaction details along with their ward’s details through email at the address spcsedisapp@gmail.com.
                  
                  </p>
                  <p>The administrator can define the total fee to be paid by the individual student along with the late fee charges.</p>
                  
                  
                  <h3><b>Microsoft Teams (Online School)</b></h3>
                  <p>Microsoft Teams is a persistent chat-based collaboration platform complete with document sharing, online meetings, and many more extremely useful features for study communications. The school opted for Microsoft Teams, to enable the interaction between teachers and students in remote learning scenarios, during the COVID-19 lockdown.</p>
                  
                  <p>Having an excellent database is key for being able to make creative decisions and communicate with one another. Many teachers and staff have been using new tools in their lessons provided by this platform and students are experiencing new methods of learning, which is an important and fun way to study and will give a long-lasting impact in their future. With this transition, it has become clear that, with the given physical distance between teachers and students, it’s more important than ever to help educators find the right ways to connect with students and keep them engaged, motivated, and safe in a digital world.</p>
                  <h3> <b>Virtual School</b> </h3>
                   
                  <p>An online school (virtual school) teaches students entirely or primarily online or through the internet. It has been defined as "education that uses one or more technologies to deliver instruction to students who are separated from the teacher and to support regular and substantive interaction between the students.”
                  
                  </p>
                  <p>Online education exists all around the world and is used for all levels of education. This type of learning enables individuals to earn transferable credits, take recognized examinations, or advance to the next level of education over the Internet. </p>
                  <h3> <b>Online Examination</b></h3>
                   
                  <p>The Online Examination System is a technology-driven way to simplify examination activities like defining exam patterns with question banks, defining exam timer, objective/ subjective question sections, conducting exams using the computer or mobile devices in a paperless manner.
                  
                  </p>
                  <p>Online Examination System is a cost-effective, scalable way to convert traditional pen and paper-based exams to online and paperless mode.  
                  
                  </p>
                  <p>Candidates can appear for the exam using any desktop, laptop, or mobile device with a browser. Exam results can be generated instantly for the objective type of questions.It can simplify overall examination management and result in generation activities. </p>
                  </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default Courses
